<template>
  <div class="t-datepicker-input">
    <Input
      left-icon="Calendar"
      readonly
      :disabled="disabled"
      :error-message="errorMessage"
      :value="inputValue"
      @focus="showDatePicker"
    />
    <Popup v-if="isPopupOpen" @close="hideDatePicker">
      <DatePicker :locale="localeFixed" :value="value" @input="handleInput" />
    </Popup>
  </div>
</template>

<script>
import DatePicker from './DatePicker.vue';
import Input from '../Input/Input.vue';
import Popup from '../Popup/Popup.vue';
import { formatByUnixSeconds } from './convert';
import { i18nAsideLabels } from './filters';

export default {
  data() {
    return {
      isPopupOpen: false,
    };
  },
  components: {
    DatePicker,
    Input,
    Popup,
  },
  props: {
    disabled: { type: Boolean, default: false },
    errorMessage: { type: String, default: '' },
    value: [Date, Number],
    locale: {
      type: String,
      default: 'pt-BR',
      validator: (value) => ['en-US', 'es-ES', 'pt-BR', 'en_US', 'es_ES', 'pt_BR'].includes(value),
    },
  },
  computed: {
    localeFixed() {
      return this.locale.replace('_', '-');
    },
    inputLabel() {
      return i18nAsideLabels[this.localeFixed];
    },
    inputValue() {
      if (typeof this.value === 'number') {
        const date = new Date(this.value * 1000);
        return formatByUnixSeconds(date, this.localeFixed);
      } if (this.value instanceof Date) {
        return formatByUnixSeconds(this.value, this.localeFixed);
      }
      return '';
    },
  },
  methods: {
    hideDatePicker(value) {
      this.isPopupOpen = value;
    },
    showDatePicker() {
      if (this.disabled === false) {
        this.isPopupOpen = true;
      }
    },
    handleInput(value) {
      this.hideDatePicker();
      this.value = value;
      this.$emit('input', value);
    },
  },
};
</script>

<style lang="scss">
.t-datepicker-input {
  position: relative;

  input {
    cursor: pointer;
  }
}
</style>
